import React from 'react';
import { Link } from 'react-router-dom'; // If using React Router
import './style.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <p className="not-found-text">
          Oops! The page you're looking for does not exist.
        </p>
        <Link to="/" className="not-found-link">
          Go back to homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
